
import { motion } from 'framer-motion';

export default function GalleryHero() {
  return (
    <section className="relative h-[70vh] min-h-[500px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/cecd90789fb33fcd6c4079bf377ee158.jpg"
          alt="Véhicule premium Voyage Elite sur route alpine - Chauffeur privé stations de ski"
          title="Galerie Voyage Elite - Transport privé premium Alpes"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
      </div>

      <div className="relative z-10 h-full flex flex-col items-center justify-center px-6 w-full">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          className="text-center"
        >
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm px-5 py-2 rounded-full border border-white/20 mb-6"
          >
            <i className="ri-camera-lens-line text-voyage-gold"></i>
            <span className="text-white font-inter text-sm font-medium">
              Notre Univers en Images
            </span>
          </motion.div>

          <h1 className="font-playfair text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-5">
            Galerie <span className="text-voyage-gold">Photos</span>
          </h1>
          <p className="text-white/80 font-inter text-base sm:text-lg max-w-2xl mx-auto leading-relaxed">
            Découvrez nos véhicules premium, nos services d&apos;exception et les
            paysages alpins qui accompagnent chaque trajet
          </p>
        </motion.div>
      </div>
    </section>
  );
}
